import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">为什么数百万漫迷选择汗汗漫画？来看看这些优势</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer group"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-2xl group-hover:bg-primary-500 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-2xl group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-sm md:text-base mb-2">{feature.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}